import { Injectable } from '@angular/core';
import * as amplitude from '@amplitude/analytics-browser'
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AmplitudeService {
  private apiKey: string;

  constructor() {
    this.initializeAmplitude();
  }

  /**
   * Initialize Amplitude with an API key from config
   */
  private initializeAmplitude(): void {
    this.apiKey = environment.AMPLITUDE_KEY;
    amplitude.init(this.apiKey, { defaultTracking: true });
  }

  /**
   * Log an event with optional properties
   */
  public logEvent(eventName: string, eventProperties?: Record<string, any>): void {
    const properties = eventProperties || {};
    if (Object.keys(properties).length > 0) {
      amplitude.logEvent(eventName, properties);
    } else {
      amplitude.logEvent(eventName);
    }
  }
}
